"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const payment_type_agregator_nst_1 = require("@breakmedia/prime-vue-payment/src/api/payment.type.agregator.nst");
const path = require('path');
const LABEL = 'Klarna payment type';
class KlarnaPaymentType extends payment_type_agregator_nst_1.PaymentTypeAgregator {
    constructor() {
        super(...arguments);
        this.indexname = 'klarna';
        this.label = LABEL;
        this.vueJsComponent = 'klarna-payment-type';
        this.configurationComponentAssets = [
            {
                id: 'klarna-payment-type_script',
                tag: 'script',
                attributes: {
                    type: 'text/javascript'
                },
                content: path.join(__dirname, '../../dist/klarna-settings.js')
            },
            {
                id: 'klarna-payment-type_style',
                tag: 'style',
                content: path.join(__dirname, '../../dist/css/app.css')
            },
            {
                id: 'material-icons',
                tag: 'link',
                attributes: {
                    href: 'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900|Material+Icons',
                    rel: 'stylesheet'
                }
            }
        ];
        this.configurationComponentTag = '<klarna-settings></klarna-settings>';
    }
    static getLabel() {
        return LABEL;
    }
}
exports.KlarnaPaymentType = KlarnaPaymentType;
//# sourceMappingURL=klarna-payment-type-config.js.map